import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PropertyCard, EmptyProperties } from "@/pages/dashboard/Properties";
import { BookOpen } from "lucide-react";

export default function Guides() {
  const [props, setProps] = useState(null);
  useEffect(() => { api.get("/properties").then(({ data }) => setProps(data.properties)); }, []);
  const published = (props || []).filter((p) => p.status === "published");
  const drafts = (props || []).filter((p) => p.status !== "published");

  return (
    <div className="px-4 pt-6">
      <h1 className="font-display font-extrabold text-2xl tracking-tight text-slate-900">Guide ospiti</h1>
      <p className="mt-1 text-slate-500">Gestisci le tue guide pubblicate e le bozze.</p>
      {!props ? <div className="py-20 grid place-items-center"><div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" /></div>
        : props.length === 0 ? <EmptyProperties />
          : <div className="mt-6 space-y-8">
            <Group title="Pubblicate" items={published} setProps={setProps} />
            <Group title="Bozze" items={drafts} setProps={setProps} />
          </div>}
    </div>
  );
}

const Group = ({ title, items, setProps }) => (
  <div>
    <h2 className="font-display font-bold text-lg text-slate-900 flex items-center gap-2"><BookOpen className="w-5 h-5 text-blue-500" /> {title} <span className="text-slate-400 font-normal">({items.length})</span></h2>
    {items.length ? <div className="mt-3 space-y-4">{items.map((p) => <PropertyCard key={p.id} p={p} onDeleted={(id) => setProps((x) => x.filter((y) => y.id !== id))} />)}</div> : <p className="mt-2 text-sm text-slate-400">Niente qui per ora.</p>}
  </div>
);
